<template>
  <div class="wrapper-inside">
    <!--    <previsualiseOffer :offer="selectedOffer" />-->

    <div class="bg-card text-right">
      <div class="text-left my-2">
        <span style="font-size: 0.8rem;">{{ $t('pages.my-offers.total-label', 'Total offers:') }}</span> {{ paginationMeta ? paginationMeta.total : "" }}
      </div>
      <div
        id="filtersContainer"
        class="d-flex justify-content-between flex-wrap"
      >
        <b-input
          v-model="filter.keyword"
          class="col"
          size="sm"
          :placeholder="$t('inputs.keyword.placeholder', 'Keywords')"
        />
        <b-form-select
          v-model="filter.orderBy"
          size="sm"
          :options="orderByOptions"
          class="col"
        />
        <b-form-select
          v-model="filter.filterBy"
          size="sm"
          :options="filterByOptions"
          class="col"
        />
        <b-button
          v-if="$can('jobs_manage')"
          variant="success"
          class="mb-1 new-btn col"
          size="sm"
          @click="addNewoffer()"
        >
          {{ $t('pages.my-offers.add-new-offer', 'Add new listing') }}
        </b-button>
      </div>

      <b-overlay
        :show="isOffersLoading"
        rounded="sm"
      >
        <pagination
          v-if="paginationMeta"
          :data="paginationMeta"
          size="small"
          :limit="1"
          align="center"
          @pagination-change-page="getResults"
        />
        <div v-if="offersList != ''">
          <div
            v-for="offer in offersList"
            :key="offer.id"
            class="text-left"
          >
            <offerEmployerCard
              :offer="offer"
              @archiveOffer="archiveModal = true; selectedOffer = offer"
              @multiprovince="multiprovinceOffer"
              @previsualise="previsualise"
              @editOffer="editOffer"
              @copyOffer="copyOffer"
              @destroy="destroyModal = true; selectedOffer = offer"
              @shareOffer="shareOffer"
            />
          </div>
          <pagination
            v-if="paginationMeta"
            :data="paginationMeta"
            size="small"
            :limit="1"
            align="center"
            @pagination-change-page="getResults"
          />
        </div>
        <div
          v-else
          style="padding: 100px"
        >
          <div class="text-center mt-5 mb-5">
            {{ $t('pages.my-offers.no-offers', 'There are no offers yet') }}
          </div>
        </div>
      </b-overlay>
    </div>

    <!-- Delete offer modal -->
    <b-modal
      v-model="destroyModal"
      :title="$t('modals.delete.confirm', 'Are you sure you want to delete?')"
      header-bg-variant="danger"
      header-text-variant="light"
      centered
      size="md"
      @ok="destroyModal = false; destroy(selectedOffer)"
    >
      {{ $t('modals.irrecoverable-action', 'You will not be able to recover it later!') }}
    </b-modal>

    <!-- Archive offer modal -->
    <b-modal
      v-model="archiveModal"
      :title="$t('modals.archive.confirm', 'Are you sure you want to archive?')"
      header-bg-variant="danger"
      header-text-variant="light"
      centered
      size="md"
      :ok-title="$t('generic.accept', 'Accept')"
      :cancel-title="$t('generic.cancel', 'Cancel')"
      @ok="archiveModal = false; archiveOffer(selectedOffer)"
    >
      <div class="mb-2">
        {{ $t('modals.archive.title', 'You will not be able to recover it later!') }}
      </div>
      <div style="font-size: 0.9rem;">
        {{ $t('modals.irrecoverable-action', 'You will not be able to recover it later!') }}
      </div>
    </b-modal>

    <!-- Share offer modal -->
    <b-modal
      v-model="shareModal"
    >
      <ShareOffer
        :url="offerUrl"
        :title="sharedOffer.titleTitle"
        :description="sharedOffer.titleDescription"
        :quote="$t('pages.my-offers.share-offer.default-message', 'I have found a job offer in :portal', {portal: appName})"
      />
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';

// import previsualiseOffer from '@/components/jobs/blocks/previsualiseOffer';
import offerEmployerCard from '@/components/jobs/blocks/offerEmployerCard';
import ShareOffer from '@/components/jobs/infoSidebar/ShareOffer';

export default {
  components: {
    // previsualiseOffer,
    offerEmployerCard,
    ShareOffer
  },
  data() {
    return {
      archiveModal: false,
      debounce: null,
      destroyModal: false,
      shareModal: false,
      sharedOffer: {},
      selectedOffer: {},
      paginationMeta: null,
      filter: {
        keyword: '',
        orderBy: '',
        filterBy: '',
      },
      page: 1,
      filterPreInit: true,
      counter: 0,
      isOffersLoading: false
    }
  },
  computed: {
    ...mapGetters('offers', {
      offerLoading: 'isLoading',
      offersList: 'list'
    }),

    ...mapState([
      'route', // vuex-router-sync
    ]),

    orderByOptions() {
      return [
        {
          label: this.$t('pages.my-offers.filters.order-by-title', 'Order offers by'),
          options: [
            { value: '', text: this.$t('pages.my-offers.filters.order-by.newest', 'Newest') },
            { value: 'updated_at', text: this.$t('pages.my-offers.filters.order-by.last_update', 'Last updated') },
            { value: 'title', text: this.$t('pages.my-offers.filters.order-by.title', 'Title') },
            { value: 'province', text: this.$t('pages.my-offers.filters.order-by.province', 'Province') },
          ]
        }
      ]
    },

    filterByOptions() {
      return [
        {
          label: this.$t('pages.my-offers.filters.show-title', 'Order offers by'),
          options: [
            { value: '', text: this.$t('pages.my-offers.filters.show.all', 'All') },
            { value: 'active', text: this.$t('pages.my-offers.filters.show.active', 'Active') },
            { value: 'archived', text: this.$t('pages.my-offers.filters.show.archived', 'Archived') },
            { value: 'unpaid', text: this.$t('pages.my-offers.filters.show.unpaid', 'Unpaid') },
          ]
        }
      ]
    },

    appName() {
      return process.env.VUE_APP_NAME;
    },

    offerUrl() {
      return process.env.VUE_APP_PUBLIC_URL + "/jobs/offer/" + this.sharedOffer.id + "/" + this.generateSlug;
    },

    generateSlug() {
      if(Object.keys(this.sharedOffer).length !== 0) {
        let slug = this.sharedOffer.titleTitle.replace(/[^A-Z0-9]+/ig, "-").toLowerCase() +
          '/' + this.sharedOffer.locationProvince.replace(/[^A-Z0-9]+/ig, "-").toLowerCase();
        return slug;
      }
      return '';
    }
  },

  watch: {
    filter: {
      handler() {
        this.counter++;
        if (this.counter >= 2) {
            this.page = 1;
        }
        this.updateQueryParams();
        this.fetchDataDebounced();
      },
      deep: true,
    },
  },
  created() {
    let queryParams = { ...this.$route.query };
    delete queryParams.page;
    this.filter = { ...queryParams };
    this.page = this.$route.query.page;
    this.fetchData();
    this.filter.orderBy = '';
    this.filter.filterBy = '';
  },
  methods: {
    addNewoffer() {
      this.$router.push({ name: 'publish-offer' });
    },
    ...mapActions('offers', {
      fetchOffers: 'fetchList',
      destroyOffer: 'destroy'
    }),
    fetchDataDebounced() {
      if (this.debounce) {
        clearTimeout(this.debounce);
        delete this.debounce;
      }

      this.debounce = setTimeout(this.fetchData, 750);
    },
    fetchData() {
      this.isOffersLoading = true;
      return this.fetchOffers({ customUrl: '/offer/user/get', config: { params: { ...this.filter, page: this.page } } })
        .then( (response) => {
          this.paginationMeta = response.meta;
          this.isOffersLoading = false;
        })
        .catch(() => {
          this.$toastSomethingWentWrong();
        });
    },
    updateQueryParams() {
      let filterParams = {};
      for (let f in this.filter) {
        if (!this.filter.hasOwnProperty(f)) {
          continue;
        }

        filterParams[f] = this.filter[f];
      }

      filterParams.page = this.page;
      this.$router.replace({ query: { ...filterParams } })
    },
    getResults(page) {
      page = page || this.page || 1;
      this.$router.replace({ query: { ...this.$route.query, page } });
      const config = {
        params: {
          page: page,
          ...this.filter,
        },
      };

      this.page = page;

      this.fetchOffers({ customUrl: '/offer/user/get', config })
        .then( res => {
          this.paginationMeta = res.meta;
          window.scrollTo(0,0);
        })
    },
    archiveOffer() {
      let offerId = { id: this.selectedOffer.id };
      this.axios.post('/offer/archive', offerId)
        .then(() => {
          this.fetchData();
          this.$toastNotification('success', '', this.$t('modals.archive.success', 'Archived successfully'));
        })
        .catch((error) => {
          this.$toastNotification('danger', '', error.response.data.error);
        });
    },
    editOffer(offer) {
      this.$router.push({ name: 'edit-offer', params: { id: offer.id } });
    },
    copyOffer(offer) {
      this.$router.push({ name: 'copy-offer', params: { id: offer.id } });
    },
    multiprovinceOffer(offer) {
      this.$router.push({ name: 'multiprovince-offer', params: {id: offer.id }})
    },
    destroy() {
      return this.destroyOffer({id: this.selectedOffer.id})
        .then(() => {
          this.$toastNotification('success', '', this.$t('modals.delete.success', 'Deleted successfully'));
        })
        .catch( (error) => {
          this.$toastNotification('danger', '', error.response.data.error);
        });
    },
    async previsualise(offer) {
      await this.axios
        .get('/offer/one/' + offer.id)
        .then( response => {
          this.selectedOffer = response.data
        })
        .catch( error => {
          console.error(error.response.data.error)
        });

      this.$bvModal.show('previsualise-modal');
    },
    shareOffer(offer) {
      this.sharedOffer = offer;
      this.shareModal = !this.shareModal;
    }
  },
}
</script>

<style lang="scss">
  td {
    font-size: 0.9rem;
  }

  .icon {
    cursor: pointer;
  }

  .new-btn {
    background: #009090;
    border-color: #009090;
  }

  #filtersContainer {
    * {
      margin: 5px;
    }

    button {
      min-width: 200px;
    }

    select, input {
      min-width: 200px;
    }
  }
</style>
